/**
 * @flow
 */

import {
  TOGGLE_CANCEL_ORDER_MODAL,
  TOGGLE_TICKET_TRANSFER_MODAL,
  TOGGLE_CANCEL_TICKET_TRANSFER_MODAL,
  TOGGLE_TICKET_TRANSFER_DISABLED_MODAL,
  TOGGLE_RESEND_TICKET_TRANSFER_MODAL,
  TOGGLE_REFUND_MODAL,
  TOGGLE_CHANGE_DATE_MODAL,
  TOGGLE_EDIT_BUYER_INFO_MODAL,
  TOGGLE_EDIT_GUEST_INFO_MODAL,
  TOGGLE_PAY_INSTALLMENT_MODAL,
  TOGGLE_PAY_INSTALLMENTS_MODAL,
  TOGGLE_GENERATE_INVOICE_CONFIRMATION_MODAL,
  TOGGLE_CANCEL_EVENT_DISCLOSURE_MODAL,
  OPEN_TICKET_TRANSFER_MODAL,
  CLOSE_TICKET_TRANSFER_MODAL,
  TOGGLE_BOOKING_PROTECTION_MODAL
} from './actions';

import {
  GENERATE_INVOICE_SUCCESS
} from '../invoice/actions';

import {
  CANCEL_ORDER_SUCCESS,
  TRANSFER_TICKET_SUCCESS,
  SEND_HOST_MESSAGE_SUCCESS,
  UPDATE_COST_ITEM_HOST_FIELDS_SUCCESS,
  UPDATE_TICKET_HOST_FIELDS_SUCCESS,
  CANCEL_TICKET_TRANSFER_SUCCESS,
  RESEND_TICKET_TRANSFER_SUCCESS,
} from '../my-tickets/actions';

const initialState = {
  showCancelOrderModal: false,
  showTransferTicketModal: false,
  showCancelTransferTicketModal: false,
  showTransferTicketDisabledModal: false,
  showResendTransferTicketModal: false,
  showRefundModal: false,
  showChangeDateModal: false,
  showGuestInfoModal: false,
  showBuyerInfoModal: false,
  showPayInstallmentModal: false,
  showPayRemainingInstallmentsModal: false,
  showGenerateInvoiceConfirmationModal: false,
  showEventDisclosureModal: false,
  showBookingProtection: false,
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case TOGGLE_PAY_INSTALLMENT_MODAL:
      return Object.assign({}, state, {
        showPayInstallmentModal: !state.showPayInstallmentModal
      });

    case TOGGLE_PAY_INSTALLMENTS_MODAL:
      return Object.assign({}, state, {
        showPayRemainingInstallmentsModal: !state.showPayRemainingInstallmentsModal
      });

    case TOGGLE_CANCEL_ORDER_MODAL:
      return Object.assign({}, state, {
        showCancelOrderModal: !state.showCancelOrderModal
      });

    case TOGGLE_TICKET_TRANSFER_MODAL:
      return Object.assign({}, state, {
        showTransferTicketModal: !state.showTransferTicketModal
      });

    case OPEN_TICKET_TRANSFER_MODAL:
      return Object.assign({}, state, {
        showTransferTicketModal: true
      });

    case CLOSE_TICKET_TRANSFER_MODAL:
      return Object.assign({}, state, {
        showTransferTicketModal: false
      });

    case TOGGLE_CANCEL_TICKET_TRANSFER_MODAL:
      return Object.assign({}, state, {
        showCancelTransferTicketModal: !state.showCancelTransferTicketModal
      });

    case TOGGLE_TICKET_TRANSFER_DISABLED_MODAL:
      return Object.assign({}, state, {
        showTransferTicketDisabledModal: !state.showTransferTicketDisabledModal
      });

    case TOGGLE_RESEND_TICKET_TRANSFER_MODAL:
      return Object.assign({}, state, {
        showResendTransferTicketModal: !state.showResendTransferTicketModal
      });

    case RESEND_TICKET_TRANSFER_SUCCESS:
      return Object.assign({}, state, {
        showResendTransferTicketModal: false
      });

    case CANCEL_TICKET_TRANSFER_SUCCESS:
      return Object.assign({}, state, {
        showCancelTransferTicketModal: false
      });

    case TOGGLE_REFUND_MODAL:
      return Object.assign({}, state, {
        showRefundModal: !state.showRefundModal
      });

    case TOGGLE_CHANGE_DATE_MODAL:
      return Object.assign({}, state, {
        showChangeDateModal: !state.showChangeDateModal
      });

    case TOGGLE_EDIT_GUEST_INFO_MODAL:
      return Object.assign({}, state, {
        showGuestInfoModal: !state.showGuestInfoModal
      });

    case TOGGLE_EDIT_BUYER_INFO_MODAL:
      return Object.assign({}, state, {
        showBuyerInfoModal: !state.showBuyerInfoModal
      });

    case CANCEL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        showCancelOrderModal: false
      });

    case TRANSFER_TICKET_SUCCESS:
      return Object.assign({}, state, {
        showTransferTicketModal: true
      });

    case SEND_HOST_MESSAGE_SUCCESS:
      return Object.assign({}, state, {
        showRefundModal: false
      });

    case UPDATE_COST_ITEM_HOST_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        showGuestInfoModal: false
      });

    case UPDATE_TICKET_HOST_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        showBuyerInfoModal: false
      });

    case TOGGLE_GENERATE_INVOICE_CONFIRMATION_MODAL:
      return Object.assign({}, state, {
        showGenerateInvoiceConfirmationModal: !state.showGenerateInvoiceConfirmationModal
      });

    case GENERATE_INVOICE_SUCCESS:
      return Object.assign({}, state, {
        showGenerateInvoiceConfirmationModal: !state.showGenerateInvoiceConfirmationModal
      });

    case TOGGLE_CANCEL_EVENT_DISCLOSURE_MODAL:
      return Object.assign({}, state, {
        showEventDisclosureModal: !state.showEventDisclosureModal
      });

    case TOGGLE_BOOKING_PROTECTION_MODAL:
      return Object.assign({}, state, {
        showBookingProtection: !state.showBookingProtection
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/modal/reducer.js